import { Cover } from "@components/anti/Cover"
import Link from "@components/anti/Link"
import { useEffect, useState } from "react"
import { useWindowSize } from "rooks"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function HomeCover({ data, locale }) {
  const [trigger, anim] = useScrollAnim("slideInUp")

  const { innerWidth } = useWindowSize()
  const [width, setWidth] = useState(null)

  useEffect(() => {
    setWidth(innerWidth)
  }, [innerWidth])

  return (
    <section className="sc-home-cover" ref={trigger}>
      <Cover
        img="/img/bg/img_bg-main-banner-mobile-new.jpg"
        imgMd="/img/bg/img_bg-main-banner.png"
        imgHeight="h-vh-100"
        title=""
        text=""
        contentMaxWidth=""
        scrollHint
        scrollHintPosition={width > 576 ? "left" : "right"}
        imgQuality={100}
        useNextImage
      >
        <div className="row">
          <div className="col-sm-6 col-title">
            <div className="overflow-hidden">
              <h1 className={`title ${anim(1)}`}>
                {data?.[`title_${locale}`]}
              </h1>
            </div>
          </div>
          <div className="col-sm-6 col-text">
            <div className="col-text-wrapper">
              <div className="overflow-hidden">
                <div className="text">
                  {convertHtmlToReact(data?.[`description_${locale}`])}
                </div>
              </div>
              <div className="overflow-hidden">
                <Link href={data?.link_url} withArrow>
                  {data?.[`link_label_${locale}`]}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Cover>
    </section>
  )
}

export default HomeCover
